/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description Edit Batch upload
 */
import { Button, ButtonProps, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { Edit } from '@icon-park/react';

import { getEditBatchRequestPath } from 'utils/router';
import EventTracker from 'utils/eventTracker';
import { EVENTS } from 'app-constants/events';

/**
 * Edit Batch Upload
 *
 */
const EditBatchUpload: React.FC<{ batchMeta: EligibilityBatchUpload.IBatchEligibilityResponseList; iconOnly?: boolean } & ButtonProps> = ({
	batchMeta,
	iconOnly,
	...restProps
}) => {
	return (
		<Link
			key='edit-batch-upload'
			to={getEditBatchRequestPath(batchMeta.batchId)}
			onClick={() => {
				EventTracker.trackEvent(EVENTS.eligibilityBatchUpload.editBatch(batchMeta.sequenceId));
			}}
		>
			{iconOnly && (
				<Tooltip title='Edit Batch'>
					<Button color='default' icon={<Edit />} {...restProps} />
				</Tooltip>
			)}
			{!iconOnly && <Button {...restProps}>{batchMeta?.sequenceId}</Button>}
		</Link>
	);
};

export default EditBatchUpload;
